import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { LocalizeProvider, withLocalize } from 'react-localize-redux';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../global/muiTheme';
import initLocalize from '../utils/initLocalize';
import useDownloadPolling from './useDownloadPolling';
import DownloadLog from './DownloadLog';

const LocalizedDownloadLog = withLocalize(function DownloadLogWithLocale({
    initialize,
    addTranslationForLanguage,
}) {
    React.useEffect(() => {
        initLocalize({ initialize, addTranslationForLanguage });
    }, []);
    const state = useDownloadPolling();
    return <DownloadLog {...state} />;
});

export default function DownloadLogPage({ store }) {
    return (
        <Provider store={store}>
            <LocalizeProvider store={store}>
                <ThemeProvider theme={theme}>
                    <LocalizedDownloadLog />
                </ThemeProvider>
            </LocalizeProvider>
        </Provider>
    );
}

DownloadLogPage.propTypes = {
    store: PropTypes.shape({
        dispatch: PropTypes.func.isRequired,
        getState: PropTypes.func.isRequired,
        subscribe: PropTypes.func.isRequired,
    }).isRequired,
};
